<nav class="navbar"
  [ngClass]="{'navbar-hide': !((componentRender === 'BeforeLogin' && !userLoggedIn) || isBookingScreen)}">
  <a *ngIf="partnerLoaded && ((componentRender === 'BeforeLogin' && !userLoggedIn) || isBookingScreen)"
    class="logo-brand" href="https://www.airportr.com">
    <img class="img-responsive serviced-by logo " alt="Go to homepage" src="./images/branding/airportr/logo.svg">
  </a>


  <ul class="nav navbar-nav navbar-right navbar-user" *ngIf="isErrorScreen">
    <li>
      <app-language-selector></app-language-selector>
    </li>
  </ul>

  <ul class="nav navbar-nav navbar-right navbar-mobile" *ngIf="!isErrorScreen">
    <li>
      <app-language-selector></app-language-selector>
    </li>
  </ul>

</nav>
